import type { enCommon } from '../en/common.js';

export const deCommon: Record<keyof typeof enCommon, string> = {
  'when.format': '{date} um {time} Uhr',
  'lang.label': 'Sprache',
  'common.cancel': 'Abbrechen',
  'common.close': 'Schließen',
  'common.save': 'Speichern',
  'common.delete': 'Löschen',
  'common.add': 'Hinzufügen',
  'common.remove': 'Entfernen',
  'common.done': 'Fertig',
  'common.back': 'Zurück',
  'common.loading': 'Wird geladen…',
  'common.yes': 'Ja',
  'common.no': 'Nein',
  'common.none': 'Keine',
  'common.guest': 'Gast',
  'common.guests_one': '{n} Gast',
  'common.guests_other': '{n} Gäste',
  'common.ppl': '{n} Pers.',
};
